import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'lib-modal-ver-archivo',
  templateUrl: './modal-ver-archivo.component.html',
  styleUrls: ['./modal-ver-archivo.component.scss']
})
export class ModalVerArchivoComponent implements OnInit {

  fileUrl: any;

  constructor(
    private dialogRef: MatDialogRef<ModalVerArchivoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { blob: any },
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const dataType = this.data.blob.type;
    const binaryData = [];
    binaryData.push(this.data.blob);

    console.log(window.URL.createObjectURL(
      new Blob(binaryData, { type: dataType }),
    ));

    this.fileUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(
      new Blob(binaryData, { type: dataType }),
    ));
  }

  handleClose = () => {
    this.dialogRef.close();
  }
}
